import { Component, forwardRef, Input } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'digi-textarea',
  templateUrl: './input-text-area.component.html',
  styleUrl: './input-text-area.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextAreaComponent),
      multi: true,
    },
  ],
})
export class InputTextAreaComponent {
  @Input() label: string = 'Text Area';
  @Input() placeholder: string = '';
  @Input() rows: string = '3';
  @Input() cols: number = 20;
  @Input() disabled: boolean = false;
  @Input() required: boolean = false;
  @Input() hint: string = '';
  @Input() errorMessage: string = '';
  @Input() isSubmit: boolean = false;
  @Input() control!: FormControl;

  value: string = '';

  onChange: (value: string) => void = () => { };
  onTouched: () => void = () => { };

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(event: Event): void {
    const inputValue = (event.target as HTMLTextAreaElement).value;
    this.value = inputValue;
    this.onChange(inputValue);
    this.onTouched();
  }
}
